<template>
  <div class="post" >
    <div class="post-header">
      <a class="post-author" href="#"
      >
      <img :src="`/storage/images/artist/${profile}`" alt=""/>
        <div class="detail">
          <div class="name">{{ name }}</div>
          <div class="job-title">Content creator</div>
          <div class="date">{{ time }}</div>
        </div>
      </a>
      <!-- <a class="more" href="#">
        <icon icon="la-equals" :size="20" color="#5096ec"></icon>
      </a> -->
      <span class="badge badge--danger" v-if="locked">
        <i class="las la-lock" style="font-size: 20px"></i>
      </span>
    </div>
    <div v-if="!locked" class="post-content">
      <p v-html="description"></p>
      <!--      <p><a href="#">#stevejobs</a><a href="#">#design</a><a href="#">#apple</a></p>-->

      <p v-if="images.length === 0 && video == null">
        <img :src="portrait" alt="Portrait"/>
      </p>
      <p v-else-if="images.length === 0 && video != null">
        <!-- {{ video.content }} -->
        <iframe
            :src="`https://iframe.videodelivery.net/${video.content}?enablejsapi=1`"
            class="w-100" style="height: 60vh" :id="`cloudflare-video-${itemId}`"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
            webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        <!--        <vue-iframe
                  :src="`https://iframe.videodelivery.net/${video.content}?enablejsapi=1`"
                  class="w-100"
                  style="height: 60vh"
                  :frame-id="`cloudflare-video-${itemId}`"
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  @load="onLoad"
                  @scroll="onScroll"
                ></vue-iframe>-->
      </p>
      <p v-else>
        <vueper-slides fixed-height="500px">
          <vueper-slide
              v-for="(slide, i) in images"
              :key="i"
              :image="slide.image"
          >
          </vueper-slide>
        </vueper-slides>
      </p>
    </div>
    <div class="post-content" v-else>
      <div class="trailer-thumb">
        <div class="trailer-thumb-overlay">
          <a class="video-icon" href="#"><i class="fas fa-play"></i></a>
        </div>
      </div>
      <p v-html="description"></p>
      <div
          class="play-container"
          :style="{ backgroundImage: 'url(' + thumbnail + ')' }"
      >
        <a :href="url" target="_blank">
          <img
              src="/images/vue/image/output-onlinegiftools%20(1).gif"
              alt="Play"
          />
        </a>
      </div>
    </div>
    <div v-if="!locked" class="post-alt-detail">
      <a class="likes">{{ Number(likes).toLocaleString() }} likes</a>
      <a href="#" @click.prevent="showPost" class="comments">
        {{ Number(comments).toLocaleString() }} Comments
      </a>
    </div>
    <div v-if="!locked" class="post-actions">
      <a href="#" @click.prevent="like" :class="{ liked: liked }">
        <i class="fas fa-heart me-2" style="font-size: 20px"></i>
        Like</a
      >
      <!--      <a href="#" @click.prevent="() => (comment = !comment)">
              <i class="fas fa-comment me-2"></i>
              Comment</a
            >-->
      <a href="#" @click.prevent="sharePopup">
        <i class="fas fa-share me-2"></i>
        Share</a
      >
    </div>
    <div class="post-comment-form" v-if="!locked && comment">
      <img src="/images/vue/image/avatar.jpeg" alt=""/>
      <form
          class="textarea"
          method="post"
          action="#"
          @submit.prevent="addComment"
      >
        <div class="input-icon-container">
          <input
              type="text"
              name="comment"
              required
              class="form-control"
              v-model="commentText"
              placeholder="Add a comment..."
          />
          <button class="icon-btn" title="Submit comment">
             <icon icon="la-paper-plane" :size="20" color="white"></icon>
          </button>
        </div>

      </form>
    </div>

    <ReelItemModal
        v-if="!locked"
        :images="images"
        :portrait="portrait"
        :item-id="itemId"
        :title="title"
        :auth="auth"
        :comments="comments"
        :description="description"
        :likes="likes"
        :name="name"
        :profile="profile"
        :time="time"
        @commented="externalComment"
        :postComments="postComments"
        @liked="like"
        :video="video"
        :liked="liked"
    />
    <!--    share modal-->
    <ShareModal :itemId="itemId" :name="title" url=""/>
  </div>
</template>

<script>
import Icon from "./Icon";
import axios from "axios";
import {VueperSlide, VueperSlides} from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import ReelItemModal from "./ReelItemModal";
import ShareModal from "../creator/components/share-modal";

export default {
  name: "reel",
  props: [
    "itemId",
    "name",
    "title",
    "time",
    "profile",
    "description",
    "portrait",
    "likes",
    "comments",
    "auth",
    "images",
    "video",
    "liked",
    "locked",
    "thumbnail",
  ],
  components: {ShareModal, ReelItemModal, Icon, VueperSlides, VueperSlide},
  data() {
    return {
      comment: true,
      commentText: "",
      postComments: [],
    };
  },
  methods: {
    addView() {
      if (this.locked) return;
      axios
          .patch(`/creators/items/${this.itemId}/add-views`, {
            itemId: this.itemId,
          })
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
    },
    onLoad(frame) {
      console.log(this.myIframe);
    },

    async like() {

      if (!this.auth) {
        notify("error", "You need to login first");
        return;
      }
      try {
        const res = await axios.post(`/item/${this.itemId}/like`);
        this.likes = Number(this.likes) + Number(res.data.value);
        this.liked = !this.liked;
      } catch (e) {
        notify("error", "You need to login first");
        console.log(e);
      }
    },
    async externalComment(comment) {
      this.commentText = comment;
      await this.addComment();
    },
    async addComment() {
      if (!this.auth) {
        notify("error", "You need to login first");
        return;
      }
      try {
        const res = await axios.post(`/item/${this.itemId}/comment`, {
          comment: this.commentText,
        });
        this.comments++;
        this.commentText = "";
        this.postComments.unshift(res.data.commentObj);
        // this.postComments.push(res.data.commentObj);
      } catch (e) {
        notify("error", "Something went wrong");
        console.log(e);
      }
    },



    showPost() {
      const videos = document.querySelectorAll('iframe, video');
      Array.prototype.forEach.call(videos, function (video) {
        if (video.tagName.toLowerCase() === 'video') {
          video.pause();
        } else {
          video.src = video.src;
        }
      });
      $(`#ReelModal${this.itemId}`).modal("show");
      this.getComments();
    },

    async getComments() {
      try {
        const res = await axios.get(`/item/${this.itemId}/comments`);
        this.postComments = res.data.comments;
      } catch (e) {
        notify(
            "error",
            "Something went wrong, please check your Internet and try again."
        );
        console.log(e);
      }
    },
    sharePopup() {
      $(`#shareModal${this.itemId}`).modal("show");
    },
  },
  computed: {
    url() {
      return `${window.location.origin}/watch-video/${this.itemId}`;
    },
  },
  created() {
    this.addView();
  }
};
</script>

<style lang="scss" scoped>
.post {
  background-color: #1f2638;
  border-radius: 10px;
  padding: 13px 20px;
  margin-bottom: 20px;

  .post-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 9px;

    .post-author {
      display: flex;
      align-items: center;

      img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin-right: 12px;
      }

      .name {
        font-size: 14px;
        font-weight: bold;
        color: #f5f7fa;
      }

      .date,
      .job-title {
        font-size: 12px;
        color: #9ca3af;
      }

      .job-title {
        padding: 2px 0;
      }
    }

    .more {
      color: #aaa;
      font-size: 18px;

      &:hover {
        color: var(--color);
      }
    }
  }

  .post-content {
    padding: 20px 0;

    p {
      font-size: 14px;
      margin-bottom: 12px;

      img {
        width: 100%;
        max-height: 500px;
        object-fit: cover;
        object-position: top;
        border-radius: 3px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      a {
        font-weight: 500;
        color: var(--color);

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .post-actions {
    display: flex;
    padding-bottom: 20px;
    justify-content: space-between;

    .liked i {
      color: #ef4444;

      &:hover {
        opacity: 0.9;
      }
    }

    a {
      font-size: 14px;
      color: #e5e7eb;
      margin-right: 15px;
      display: flex;
      align-items: center;
      transition: 0.2s;
      background-color: transparent;
      padding: 5px 10px;
      border-radius: 10px;

      &:hover {
        background-color: #2b354e;
      }

      svg {
        font-size: 20px;
        margin-right: 5px;
      }

      &:hover {
        color: var(--color);
      }
    }
  }

  .post-alt-detail {
    display: flex;
    font-size: 12px;
    justify-content: space-between;
    color: #d1d5db;
    align-items: center;
    padding-bottom: 14px;
    margin-bottom: 14px;

    .comments {
      transition: 0.2s;
      font-size: 14px;

      &:hover {
        opacity: 0.7;
      }
    }

    .likes {
      display: flex;
      margin-right: 10px;
      padding-right: 10px;
      align-items: center;
      position: relative;

      &::before {
        content: "";
        width: 2px;
        height: 2px;
        border-radius: 50%;
        background: #17272f;
        position: absolute;
        top: 50%;
        right: -1px;
        margin-top: -1px;
      }
    }

    svg {
      font-size: 14px;
      margin-right: 10px;
      position: relative;
      z-index: 1;

      &::after {
        content: "";
        width: 11px;
        height: 11px;
        border-radius: 50%;
        position: absolute;
        top: 2px;
        left: 2px;
        z-index: -1;
      }

      &.icon-heart {
        color: #e52a34;

        &::after {
          background: rgba(#e52a34, 0.32);
        }
      }

      &.icon-thumbs-up {
        color: #388bf2;

        &::after {
          background: rgba(#388bf2, 0.32);
        }
      }
    }
  }

  .post-comment-form {
    display: flex;
    align-items: center;

    img {
      min-width: 32px;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .textarea {
      flex: 1;
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 8px;

      input {
        background: transparent;
        width: 100%;
        flex: 1;
        padding: 8px;
        border-radius: 40px;
        color: white;
        border: 1px solid #64748b;

        &::placeholder {
          color: #cbd5e1;
        }
      }

      label {
        cursor: pointer;
        padding-left: 16px;
        font-size: 18px;
        color: #a7b4cc;
        padding-right: 5px;

        &:hover {
          color: var(--color);
        }

        input {
          display: none;
        }
      }
    }
  }
}

.vueperslide,
.vueperslide__image {
  background-position: top !important;
}

.play-container a::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
  bottom: 0;
  left: 0;
  border-radius: 0;
  border-radius: 50%;
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
  -webkit-animation: ripple 1.8s ease-out infinite;
  animation: ripple 1.8s ease-out infinite;
  background-color: #d50055;
}

.play-container {
  padding-top: 30px;
  padding-bottom: 45px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 100px;
  }
}

.input-icon-container {
  position: relative;
  display: flex;
  width: 100%;
}

.icon-btn {
  width: 2em;
  height: 2em;
  border-radius: 50%;
  padding-right: 25px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-btn i {
  font-size: 1.1em;
  color: #cbd5e1;
}
</style>
